<template lang="pug">
  .w-24.h-24
    //- <svg >
    //-   <polygon points="18.43 7.72 19.5 8.78 12 16.28 4.5 8.78 5.57 7.72 12 14.16 18.43 7.72"/>
    //- </svg>
    iCon.overflow-hidden(:iconClass="'dropdown'"  type="svg")
</template>
<script>
export default {
  name: 'OpenIndicator',
  props: {
  },
}
</script>
<style lang="scss" scoped>


</style>
